import { render, staticRenderFns } from "./OfferFieldsDisplay.vue?vue&type=template&id=3320a180&"
import script from "./OfferFieldsDisplay.vue?vue&type=script&lang=js&"
export * from "./OfferFieldsDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VChip,VSlider})
